export interface SportMatchLsportsDTO {
  id: number;
  name: string | null;
  status: string | null;
  start_date: string | null;
  last_update: string | null;
}

export interface SportLeagueLsportsDTO {
  id: number;
  name: string;
  location_id: number;
  location_name: string;
}

export interface SportParticipantLsportsDTO {
  id: number;
  name: string;
  position: number;
}

export interface SportApisportsRefDTO {
  id: number;
  name: string;
}

export interface SportMatchParticipantDTO {
  id: string;
  team_id: string;
  lsports: SportParticipantLsportsDTO | null;
  apisports: SportApisportsRefDTO | null;
}

export interface SportMatchLeagueDTO {
  id: string;
  lsports: SportLeagueLsportsDTO | null;
  apisports: SportApisportsRefDTO | null;
}

// Which entity an APISports mapping targets — maps directly to the URL path
// segment: /admin/mappings/{kind}/{entityId}
export type MappingKind = 'leagues' | 'teams' | 'matches';

export interface ApiSportsMappingValue {
  id: number;
  name: string;
  logo: string;
  country: string;
}

export interface ApiSportsMappingsResponse {
  search_query: string;
  values: ApiSportsMappingValue[];
}

// A season of a competition. `season` is the identifier the matches mapping
// search expects - a plain string such as "2024", not a numeric id.
export interface LeagueSeasonDTO {
  season: string;
  start: string;
  end: string;
}

export interface LeagueSeasonsResponse {
  seasons: LeagueSeasonDTO[];
}

export interface MatchMappingTeamDTO {
  id: number;
  name: string;
  logo: string;
  country: string | null;
}

// Raw shape of a single entry in the /admin/mappings/matches/{id} array.
export interface MatchMappingDTO {
  id: number;
  start_date?: string | null;
  title?: string | null;
  home?: MatchMappingTeamDTO | null;
  away?: MatchMappingTeamDTO | null;
}

export interface SportMatchDTO {
  id: string;
  league: SportMatchLeagueDTO;
  participants: SportMatchParticipantDTO[];
  lsports: SportMatchLsportsDTO;
  apisports: SportApisportsRefDTO | null;
}

export interface SportMatchActivationTournament {
  id: string;
  name: string;
}

export enum SportMatchStatus {
  pending = 1,
  inProgress = 2,
  ended = 3,
  interrupted = 4,
  canceled = 5,
  walkover = 6,
  abandoned = 7,
  retired = 8,
}

const SPORT_MATCH_STATUS_LABELS: Record<SportMatchStatus, string> = {
  [SportMatchStatus.pending]: 'Pending',
  [SportMatchStatus.inProgress]: 'In progress',
  [SportMatchStatus.ended]: 'Ended',
  [SportMatchStatus.interrupted]: 'Interrupted',
  [SportMatchStatus.canceled]: 'Canceled',
  [SportMatchStatus.walkover]: 'Walkover',
  [SportMatchStatus.abandoned]: 'Abandoned',
  [SportMatchStatus.retired]: 'Retired',
};

export const formatSportMatchStatus = (status: SportMatchStatus): string =>
  SPORT_MATCH_STATUS_LABELS[status] ?? String(status);

export interface SportMatchActivationItem {
  id: string;
  externalId: number;
  name: string;
  status: SportMatchStatus;
  startTime: Date | null;
  activatedAt: Date | null;
  tournament: SportMatchActivationTournament;
}
